import React from 'react';
import PropTypes from 'prop-types';
import { ShareButtons, generateShareIcon } from 'react-share';
import { OverlayTrigger, Button, Popover } from 'react-bootstrap';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import NotificationModal from 'components/SharedComponents/modal/notification-modal';
import * as eventCaptureService from 'app-lib/events/event-capture-service';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

const shareCopyLinkClicked = 'shareCopyLinkClicked';
const facebookShare = 'facebookShare';
const twitterShare = 'twitterShare';
const linkedinShare = 'linkedinShare';

export class SocialShare extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            linkCopied: false,
            showCopyModal: false
        };
    }

    socialShareMixpanelTracking(socialMedia) {
        const mixpanelAttributes = {socialMedia};
        (this.props.searchId) ? mixpanelAttributes.search_id = this.props.searchId : null;
        mixpanelTracker.track(`${this.props.page}-${mixpanelTracker.socialShareClicked}`, mixpanelAttributes);
    }

    sendEvent(eventName) {
        const { contentKey, title, linkValue, channelKey, channelName, identityKey, email } = this.props;
        // add event identifier attributes
        const eventBody = {
            contentKey,
            title,
            url: linkValue,
            channelKey,
            channelName,
            identityKey,
            email
        };
        // send
        eventCaptureService.send(eventName, eventBody);
    }

    copyToClipBoard(e) {
        mixpanelTracker.track(`${this.props.page}-${mixpanelTracker.shareCopyLinkClicked}`);
        this.sendEvent(shareCopyLinkClicked);
        const c = e.target.dataset.copytarget;
        const inp = (c ? document.querySelector(c) : null);

        if (inp && inp.select) {
            inp.select();
            try {
                const value = document.execCommand('copy');
                inp.blur();
                if (!value) {
                    alert('Please copy the link manually.');
                }
                this.setState({linkCopied: true});
            } catch (err) {
                alert('Please copy the link manually.');
            }
        }
    }

    facebookButton() {
        const {FacebookShareButton} = ShareButtons;
        const FacebookIcon = generateShareIcon('facebook');
        return (
            <div
              className="social-share__icon"
              id="facebook-share"
              onClick={() => {
                  this.socialShareMixpanelTracking(mixpanelTracker.valueFacebook);
                  this.sendEvent(facebookShare);
              }}
            >
                <FacebookShareButton
                  url={this.props.linkValue}
                  quote={this.props.title}
                  className="shareButton"
                >
                    <FacebookIcon size={30} round={true} />
                </FacebookShareButton>
            </div>
        );
    }

    twitterButton() {
        const {TwitterShareButton} = ShareButtons;
        const TwitterIcon = generateShareIcon('twitter');
        return (
            <div
              className="social-share__icon"
              id="twitter-share" onClick={() => {
                  this.socialShareMixpanelTracking(mixpanelTracker.valueTwitter);
                  this.sendEvent(twitterShare);
              }}
            >
                <TwitterShareButton
                  url={this.props.linkValue}
                  title={this.props.title}
                  className="shareButton"
                >
                    <TwitterIcon size={30} round={true} />
                </TwitterShareButton>
            </div>
        );
    }

    linkedinButton() {
        const {LinkedinShareButton} = ShareButtons;
        const LinkedinIcon = generateShareIcon('linkedin');

        return (
            <div
              className="social-share__icon"
              id="linkedin-share" onClick={() => {
                  this.socialShareMixpanelTracking(mixpanelTracker.valueLinkedin);
                  this.sendEvent(linkedinShare);
              }}
            >
                <LinkedinShareButton
                  url={this.props.linkValue}
                  title={this.props.title}
                  className="shareButton"
                  description={this.props.description ? this.props.description : null}
                >
                    <LinkedinIcon size={30} round={true} />
                </LinkedinShareButton>
            </div>
        );
    }

    detectmob() {
        const w = window;
        const d = document;
        const documentElement = d.documentElement;
        const body = d.getElementsByTagName('body')[0];
        const width = w.innerWidth || documentElement.clientWidth || body.clientWidth;

        if (width <= 850) {
            return true;
        }
        return false;
    }

    showCopyLinkModal() {
        const {t} = this.props;
        const onExited = () => {
            this.setState({
                showCopyModal: false
            });
        };
        const instructions = (<span><span className="select-access-header">{t('SharedComponents.modal.shareModal.shareUrl')}</span>
            <div className="social-share__copy-link social-share__copy-link--mobile">
                <a href={this.props.linkValue} target="_blank">{this.props.linkValue}</a>
            </div></span>);
        return (
            <NotificationModal
              show={true}
              header={null}
              instruction={instructions}
              actions={null}
              onExited={onExited.bind(this)}
            />
        );
    }

    copyPopover() {
        const {t} = this.props;
        return (
            <Popover className="social-share__copy-popover" id="social-share__copy-popover">
                    {
                        this.state.linkCopied ? <span className="social-share_link-copied">
                            <i className="togo-icon togo-icon-check" style={{color: 'green', marginRight: '5px'}}></i>{t('SharedComponents.social-share.link-copied')}</span> : ''
                    }
                <span className="select-access-header">{t('SharedComponents.modal.shareModal.shareUrl')}</span>
                <div className="social-share__copy-link">
                    <input type="text" id="shareLink" className="form-control" value={this.props.linkValue} readOnly />
                    <Button
                      data-copytarget="#shareLink"
                      onClick={this.copyToClipBoard.bind(this)}
                      bsClass="social-share__copy-link-button"
                    >
                            {t('SharedComponents.modal.shareModal.copy')}
                    </Button>
                </div>
            </Popover>
        );
    }

    copyShareButton() {
        if (this.detectmob()) {
            return (
                <div
                  className="social-share__icon" id="link-share" onClick={() => {
                      this.socialShareMixpanelTracking(mixpanelTracker.valueCopyLink);
                      this.setState({showCopyModal: true});
                  }}
                >
                    {this.state.showCopyModal ? this.showCopyLinkModal() : ''}
                    <span className="social-share__link-background"><i className="togo-icon togo-icon-link social-share__icon-adjust"></i></span>
                </div>
            );
        }
        return (
            <OverlayTrigger
              trigger="click" placement="bottom" overlay={this.copyPopover()} rootClose={true}
              onExited={() => this.setState({ linkCopied: false })}
            >
                <div className="social-share__icon" id="link-share" onClick={() => { this.socialShareMixpanelTracking(mixpanelTracker.valueCopyLink); }} >
                    <span className="social-share__link-background"><i className="togo-icon togo-icon-link social-share__icon-adjust"></i></span>
                </div>
            </OverlayTrigger>
        );
    }

    render() {
        return (
            <CSSTransitionGroup component="div" className="social-share" transitionName="share-animation" transitionEnterTimeout={500} transitionLeaveTimeout={500}>
                    {this.props.facebook ? this.facebookButton() : null}
                    {this.props.linkedIn ? this.linkedinButton() : null}
                    {this.props.twitter ? this.twitterButton() : null}
                    {this.props.copyShare ? this.copyShareButton() : null}
            </CSSTransitionGroup>
        );
    }
}

SocialShare.defaultProps = {
    contentKey: '',
    title: '',
    linkValue: '',
    channelKey: '',
    channelName: '',
    identityKey: '',
    email: '',
    facebook: true,
    linkedIn: true,
    twitter: true,
    copyShare: true
};

SocialShare.propTypes = {
    contentKey: PropTypes.string,
    channelKey: PropTypes.string,
    channelName: PropTypes.string,
    identityKey: PropTypes.string,
    email: PropTypes.string,
    linkValue: PropTypes.string,
    metaImage: PropTypes.string,
    t: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    page: PropTypes.string,
    facebook: PropTypes.bool,
    linkedIn: PropTypes.bool,
    twitter: PropTypes.bool,
    copyShare: PropTypes.bool,
    searchId: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/social-share.js